<div class="multiselect-box mb-1">
  <div class="control">
    <div
      class="field is-grouped is-grouped-multiline pl-2 pt-2"
      (click)="showList = !showList"
      (keydown)="showList = !showList"
      tabindex="0"
      *ngIf="selectedValues.length"
    >
      <div class="control mb-2" *ngFor="let selectedValue of selectedValues">
        <div class="tags has-addons">
          <span class="tag is-link">
            {{ selectedValue.label | stripHtml }}
          </span>

          <a
            (click)="toggleValue(selectedValue)"
            (keydown)="toggleValue(selectedValue)"
            tabindex="0"
            class="tag is-delete"
          ></a>
        </div>
      </div>
    </div>
    <div class="multisearch-input-field">
      <input
        type="text"
        class="input"
        (keyup)="onSearchInputKeyup($event)"
        tabindex="0"
        (keydown.enter)="$event.preventDefault()"
        [placeholder]="
          maxSelectedItems && selectedValues.length >= maxSelectedItems
            ? 'Maximum of ' +
              maxSelectedItems +
              ' selected items reached, remove one item to add more...'
            : selectedValues.length
            ? 'Add more...'
            : placeholder
        "
        [disabled]="
          maxSelectedItems && selectedValues.length >= maxSelectedItems
        "
        (focus)="showList = true"
        autocomplete="false"
        #searchInput
      />

      <ul
        class="box list mt-0 px-0 is-size-7 has-text-dark"
        *ngIf="showList && suggestedValues.length"
      >
        <li
          *ngFor="let value of suggestedValues; let i = index"
          [ngClass]="{
            'has-text-link has-background-primary-light':
              isAlreadySelected(value),
            'is-focused': focusedValueIndex === i
          }"
          [value]="value"
          class="pointer mb-0"
          (click)="toggleValue(value)"
          (keydown)="toggleValue(value)"
          tabindex="0"
        >
          <span innerHTML="{{ value.label | stripHtml }}"></span>
        </li>
      </ul>
      <ul
        class="box list mt-0 px-0 is-size-7 has-text-dark"
        *ngIf="addNewOptionFunction && showList && !suggestedValues.length"
      >
        <li
          (click)="addNewOption(terms)"
          (keydown)="addNewOption(terms)"
          tabindex="0"
          class="is-flex is-flex-direction-column pointer bg-link-alpha10"
        >
          <a class="button is-small is-transparent px-1 has-text-link is-bold">
            <i class="fa fa-plus-circle"></i>
            Add {{ terms }}
          </a>
          <p class="my-0">
            <span (click)="addNewOption(terms)">
              <strong>{{ terms }}</strong> does not match any existing term, you
              can add it by clicking here.</span
            >
          </p>
        </li>
      </ul>
    </div>
  </div>
</div>
